import { RequestTypes } from '../../../hooks/useRequest'

export const BILLING_API_PREFIX = '/api/billing/v1/'
export const BILLING_DELETE = 'service-package-payment'

export const buyPackage = {
    link: `${BILLING_API_PREFIX}${BILLING_DELETE}`,
    method: RequestTypes.post,
}
